export const defaultPanelList = [
  {
    id: 'BookPnL',
    dataKey: 'BookPnL',
    extraKey: 'NetExposure',
    class: 'BookPnL',
    exportExcel: 'BookPnL',
    exportExcelFilePrefix: 'FXMetals',
    bookFilterId: '',
    optionsClass: 'SettingsBook',
    optionsNoPopup: true,
    options: {
      title: 'FX/Metals',
      rootList: 'exportList',
      filter: 'sorting',
      list: 'instrumentList',
      label: 'instrumentName',
      top: 0,
      left: 0,
      width: 2070,
      height: 830,
      z: 1,
      minWidth: 550,
      showBookFilter: false,
      bookPnLMode: 0,
      lotsMios: 'mios',
      bookSet: 0,
      showNetExposure: false
    },
    status: 1
  },
  {
    id: 'Client',
    class: 'Client',
    bookFilterId: 'TopClient',
    optionsClass: 'SettingsBook',
    optionsNoPopup: true,
    options: {
      title: 'Client',
      top: 850,
      left: 0,
      width: 1580,
      height: 620,
      minWidth: 650,
      z: 1,
      showBookFilter: true
    },
    status: 1,
    subMenu: [
      {
        id: 'TopWinningClient',
        dataKey: 'TopWinningClient',
        class: 'ClientArray',
        exportExcel: 'TopWinningClient',
        exportExcelFilePrefix: 'TopWinningClient',
        options: {
          title: 'Top Winning Client',
          rootList: 'exportList',
          filter: 'sorting',
          list: 'clientList',
          label: 'accountName'
        }
      },
      {
        id: 'TopLoosingClient',
        dataKey: 'TopLoosingClient',
        class: 'ClientArray',
        exportExcel: 'TopLoosingClient',
        exportExcelFilePrefix: 'TopLosingClient',
        options: {
          title: 'Top Losing Client',
          rootList: 'exportList',
          filter: 'sorting',
          list: 'clientList',
          label: 'accountName'
        }
      },
      {
        id: 'TopActiveClient',
        dataKey: 'TopActiveClient',
        class: 'ClientArray',
        exportExcel: 'TopActiveClient',
        exportExcelFilePrefix: 'TopActiveClient',
        options: {
          title: 'Top Active Client',
          rootList: 'exportList',
          filter: 'sorting',
          list: 'clientList',
          label: 'accountName'
        }
      },
      {
        id: 'MonitoringClient',
        dataKey: 'MonitoringClient',
        class: 'ClientArray',
        exportExcel: 'MonitoringClient',
        exportExcelFilePrefix: 'MonitoringClient',
        options: {
          title: 'Monitoring Client',
          rootList: 'exportList',
          filter: 'sorting',
          list: 'clientList',
          label: 'accountName'
        }
      }
    ]
  },
  {
    id: 'Risk',
    dataKey: 'BookPnL',
    class: 'Risk',
    exportExcel: 'BookPnL',
    exportExcelFilePrefix: 'Risk',
    bookFilterId: '',
    options: {
      title: 'Risk',
      rootList: 'exportList',
      filter: 'sorting',
      list: 'instrumentList',
      label: 'instrumentName',
      top: 850,
      left: 1600,
      width: 480,
      height: 430,
      z: 1,
      minWidth: 400,
      showBookFilter: false,
      bookPnLMode: 0,
      lotsMios: 'mios',
      bookSet: 0
    },
    status: 1
  },
  {
    id: 'STPPnL',
    dataKey: 'STPPnL',
    class: 'STPPnL',
    exportExcel: 'STPPnL',
    exportExcelFilePrefix: 'STP',
    bookFilterId: '',
    optionsClass: 'SettingsBook',
    optionsNoPopup: true,
    options: {
      title: 'STP',
      rootList: 'exportList',
      filter: 'sorting',
      list: 'instrumentList',
      label: 'instrumentName',
      top: 1490,
      left: 0,
      width: 2060,
      height: 630,
      z: 1,
      minWidth: 550,
      showBookFilter: false,
      bookPnLMode: 0,
      lotsMios: 'mios'
    },
    status: 1
  },
  {
    id: 'BookDiscrepancies',
    dataKey: 'BookDiscrepancies',
    class: 'BookDiscrepancies',
    exportExcel: 'BookDiscrepancies',
    exportExcelFilePrefix: 'BookDiscrepancies',
    bookFilterId: '',
    options: {
      title: 'Book Discrepancies',
      rootList: 'exportList',
      filter: 'sorting',
      list: 'instrumentList',
      label: 'instrumentName',
      top: 2140,
      left: 0,
      width: 2060,
      height: 520,
      z: 1,
      minWidth: 550,
      showBookFilter: false,
      bookPnLMode: 1,
      lotsMios: 'lots'
    },
    status: 1
  },
  {
    id: 'BookPnL1',
    dataKey: 'BookPnL1',
    class: 'BookPnL',
    exportExcel: 'BookPnL1',
    exportExcelFilePrefix: 'Stocks',
    bookFilterId: '',
    optionsClass: 'SettingsBook',
    optionsNoPopup: true,
    options: {
      title: 'Stocks',
      rootList: 'exportList',
      filter: 'sorting',
      list: 'instrumentList',
      label: 'instrumentName',
      top: 0,
      left: 0,
      width: 700,
      height: 430,
      z: 1,
      minWidth: 400,
      showBookFilter: false,
      bookPnLMode: 0,
      lotsMios: 'mios',
      bookSet: 0
    },
    status: 0
  },
  {
    id: 'BookPnL2',
    dataKey: 'BookPnL2',
    class: 'BookPnL',
    exportExcel: 'BookPnL2',
    exportExcelFilePrefix: 'Crypto',
    bookFilterId: '',
    optionsClass: 'SettingsBook',
    optionsNoPopup: true,
    options: {
      title: 'Crypto',
      rootList: 'exportList',
      filter: 'sorting',
      list: 'instrumentList',
      label: 'instrumentName',
      top: 0,
      left: 0,
      width: 700,
      height: 430,
      z: 1,
      minWidth: 400,
      showBookFilter: false,
      bookPnLMode: 0,
      lotsMios: 'mios',
      bookSet: 0
    },
    status: 0
  },
  {
    id: 'CreditControl',
    dataKey: 'CreditControl',
    class: 'CreditControl',
    exportExcel: 'CreditControl',
    exportExcelFilePrefix: 'CreditControl',
    bookFilterId: '',
    optionsClass: 'SettingsBook',
    optionsNoPopup: true,
    options: {
      title: 'Credit Control',
      rootList: 'exportList',
      filter: 'sorting',
      list: 'clientList',
      label: 'accountName',
      top: 0,
      left: 0,
      width: 940,
      height: 430,
      minWidth: 550,
      z: 1,
      showBookFilter: false
    },
    status: 0
  },
  {
    id: 'RiskSplit',
    dataKey: 'RiskSplit',
    class: 'RiskSplit',
    exportExcel: 'RiskSplit',
    exportExcelFilePrefix: 'RiskSplit',
    bookFilterId: '',
    optionsClass: 'SettingsBook',
    optionsNoPopup: true,
    options: {
      title: 'RiskSplit',
      rootList: 'exportList',
      filter: 'sorting',
      list: 'instrumentList',
      label: 'instrumentName',
      top: 0,
      left: 0,
      width: 750,
      height: 430,
      z: 1,
      minWidth: 550,
      showBookFilter: false,
      bookPnLMode: 0,
      lotsMios: 'mios',
      bookSet: 0
    },
    status: 0
  },
  // {
  //   id: 'Reconciliation',
  //   dataKey: 'Reconciliation',
  //   class: 'Reconciliation',
  //   exportExcel: 'Reconciliation',
  //   exportExcelFilePrefix: 'Reconciliation',
  //   bookFilterId: '',
  //   optionsClass: 'SettingsBook',
  //   optionsNoPopup: true,
  //   options: {
  //     title: 'SQF Reconciliation',
  //     rootList: 'exportList',
  //     filter: 'sorting',
  //     list: 'instrumentList',
  //     label: 'instrumentName',
  //     top: 0,
  //     left: 0,
  //     width: 940,
  //     height: 300,
  //     minWidth: 550,
  //     z: 1,
  //     showBookFilter: false
  //   },
  //   status: 0
  // },
  {
    id: 'NTPLP',
    dataKey: 'NTPLP',
    class: 'NTPLP',
    exportExcel: 'NTPLP',
    exportExcelFilePrefix: 'NTPLP',
    bookFilterId: '',
    options: {
      title: 'Client NTP',
      rootList: 'exportList',
      filter: 'sorting',
      list: 'bookList',
      label: 'bookName',
      top: 0,
      left: 0,
      // left: 960,
      width: 750,
      height: 300,
      z: 1,
      showBookFilter: false
    },
    status: 0
  },
  {
    id: 'BookAggregation',
    dataKey: 'BookAggregation',
    class: 'BookAggregation',
    exportExcel: 'BookAggregation',
    exportExcelFilePrefix: 'BookAggregation',
    bookFilterId: '',
    options: {
      title: 'Book Aggregation',
      rootList: 'exportList',
      filter: 'sorting',
      list: 'instrumentList',
      label: 'instrumentName',
      top: 0,
      left: 0,
      width: 700,
      height: 330,
      z: 1,
      minWidth: 550,
      showBookFilter: false,
      bookPnLMode: 0,
      lotsMios: 'mios',
      bookSet: 0
    },
    status: 0
  },
  {
    id: 'BookSummary',
    dataKey: 'BookSummary',
    class: 'BookSummary',
    exportExcel: 'BookSummary',
    exportExcelFilePrefix: 'BookSummary',
    bookFilterId: '',
    optionsClass: 'SettingsCategory',
    optionsNoPopup: true,
    options: {
      title: 'Book Summary',
      rootList: 'exportList',
      filter: 'sorting',
      list: 'instrumentList',
      label: 'instrumentName',
      z: 1,
      minWidth: 550,
      top: 0,
      left: 0,
      width: 700,
      height: 330,
      showBookFilter: false
    },
    status: 0
  },
  {
    id: 'PnL Report',
    class: 'PnLReport',
    bookFilterId: '',
    options: {
      title: 'P/L Report',
      top: 0,
      left: 0,
      width: 940,
      height: 300,
      minWidth: 700,
      z: 1,
      showBookFilter: false
    },
    status: 0,
    subMenu: [
      {
        id: 'BookPnLReport',
        dataKey: 'PnL Report',
        class: 'BookPnLReport',
        exportExcel: 'PnL Report',
        exportExcelFilePrefix: 'BookPnLReport',
        options: {
          title: 'Book Report',
          rootList: 'exportList',
          filter: 'sorting',
          filterId: 'PnL Report',
          list: 'bookList',
          label: 'title'
        }
      },
      {
        id: 'TopExposurePnLReport',
        dataKey: 'PnL Report',
        class: 'TopExposurePnLReport',
        exportExcel: 'PnL Report',
        exportExcelFilePrefix: 'TopExposurePnLReport',
        options: {
          title: 'Top Exposure',
          rootList: 'exportList',
          filter: 'sorting',
          filterId: 'PnL Report',
          list: 'instrumentList',
          label: 'instrumentName'
        }
      }
    ]
  },
  {
    id: 'TopPosition',
    dataKey: 'TopPosition',
    class: 'InstrExpArray',
    exportExcel: 'TopPosition',
    exportExcelFilePrefix: 'TopPosition',
    bookFilterId: 'TopPosition',
    optionsClass: 'SettingsLot',
    optionsConds: [
      { groupKey: 'symbol' }
    ],
    options: {
      title: 'Top Position',
      rootList: 'exportList',
      filter: 'sorting',
      groupKey: 'TopExposureKey',
      lotsMios: 'mios',
      top: 0,
      left: 0,
      width: 460,
      height: 300,
      z: 1,
      defaultMapping: 'symbol',
      showBookFilter: true,
      mapping: {
        'symbol': {
          list: 'instrumentList',
          label: 'instrumentName'
        },
        'currency': {
          list: 'currencyList',
          label: 'currency'
        }
      }
    },
     status: 0
  },
  {
    id: 'TopLong',
    dataKey: 'TopLong',
    class: 'InstrExpArray',
    exportExcel: 'TopLong',
    exportExcelFilePrefix: 'TopLong',
    bookFilterId: 'TopLong',
    optionsClass: 'SettingsLot',
    optionsConds: [
      { groupKey: 'symbol' }
    ],
    options: {
      title: 'Top Long',
      rootList: 'exportList',
      filter: 'sorting',
      groupKey: 'TopExposureKey',
      lotsMios: 'mios',
      top: 0,
      left: 0,
      width: 460,
      height: 300,
      z: 1,
      defaultMapping: 'symbol',
      showBookFilter: true,
      mapping: {
        'symbol': {
          list: 'instrumentList',
          label: 'instrumentName'
        },
        'currency': {
          list: 'currencyList',
          label: 'currency'
        }
      }
    },
    status: 0
  },
  {
    id: 'TopShort',
    dataKey: 'TopShort',
    class: 'InstrExpArray',
    exportExcel: 'TopShort',
    exportExcelFilePrefix: 'TopShort',
    bookFilterId: 'TopShort',
    optionsClass: 'SettingsLot',
    optionsConds: [
      { groupKey: 'symbol' }
    ],
    options: {
      title: 'Top Short',
      rootList: 'exportList',
      filter: 'sorting',
      groupKey: 'TopExposureKey',
      lotsMios: 'mios',
      top: 0,
      left: 0,
      width: 460,
      height: 300,
      z: 1,
      defaultMapping: 'symbol',
      showBookFilter: true,
      mapping: {
        'symbol': {
          list: 'instrumentList',
          label: 'instrumentName'
        },
        'currency': {
          list: 'currencyList',
          label: 'currency'
        }
      }
    },
    status: 0
  },
  {
    id: 'TopWinning',
    dataKey: 'TopWinning',
    class: 'InstrPnLArray',
    exportExcel: 'TopWinning',
    exportExcelFilePrefix: 'TopWinning',
    bookFilterId: 'TopWinning',
    options: {
      title: 'Top Winning',
      rootList: 'exportList',
      filter: 'sorting',
      groupKey: 'TopPnLKey',
      top: 0,
      left: 0,
      width: 460,
      height: 300,
      z: 1,
      defaultMapping: 'symbol',
      showBookFilter: true,
      mapping: {
        'symbol': {
          list: 'instrumentList',
          label: 'instrumentName'
        },
        'currency': {
          list: 'currencyList',
          label: 'currency'
        }
      }
    },
    status: 0
  },
  {
    id: 'TopLoosing',
    dataKey: 'TopLoosing',
    class: 'InstrPnLArray',
    exportExcel: 'TopLoosing',
    exportExcelFilePrefix: 'TopLosing',
    bookFilterId: 'TopLoosing',
    options: {
      title: 'Top Losing',
      rootList: 'exportList',
      filter: 'sorting',
      groupKey: 'TopPnLKey',
      top: 0,
      left: 0,
      width: 460,
      height: 300,
      z: 1,
      defaultMapping: 'symbol',
      showBookFilter: true,
      mapping: {
        'symbol': {
          list: 'instrumentList',
          label: 'instrumentName'
        },
        'currency': {
          list: 'currencyList',
          label: 'currency'
        }
      }
    },
    status: 0
  },
  {
    id: 'Flow',
    dataKey: 'Flow',
    class: 'FlowArray',
    exportExcel: 'Flow',
    exportExcelFilePrefix: 'Flow',
    bookFilterId: 'Flow',
    options: {
      title: 'Flow PnL',
      rootList: 'exportList',
      filter: 'sorting',
      list: 'instrumentList',
      label: 'instrumentName',
      top: 0,
      left: 0,
      width: 460,
      height: 300,
      z: 1,
      showBookFilter: false
    },
    status: 0
  },
  // {
  //   id: 'Hedging',
  //   class: 'HedgeArray',
  //   exportExcel: 'Hedging',
  //   exportExcelFilePrefix: 'Hedging',
  //   bookFilterId: '',
  //   options: {
  //     title: 'Hedging',
  //     rootList: 'exportList',
  //     filter: 'sorting',
  //     groupKey: 'HedgingKey',
  //     top: 0,
  //     left: 0,
  //     width: 1270,
  //     height: 300,
  //     minWidth: 550,
  //     z: 1,
  //     defaultMapping: 'symbol',
  //     showBookFilter: false,
  //     mapping: {
  //       'symbol': {
  //         list: 'instrumentList',
  //         label: 'instrumentName'
  //       },
  //       'currency': {
  //         list: 'currencyList',
  //         label: 'currency'
  //       }
  //     }
  //   },
  //   status: 0
  // },
  {
    id: 'Order',
    class: 'Order',
    bookFilterId: '',
    options: {
      title: 'Order',
      top: 0,
      left: 0,
      width: 1270,
      height: 300,
      z: 1,
      minWidth: 550,
      showBookFilter: false
    },
    status: 0,
    subMenu: [
      {
        id: 'TopWorkingOrder',
        dataKey: 'TopWorkingOrder',
        class: 'orderArray',
        exportExcel: 'TopWorkingOrder',
        exportExcelFilePrefix: 'TopWorkingOrder',
        options: {
          title: 'Top Working Orders',
          rootList: 'exportList',
          filter: 'sorting',
          list: 'orderList',
          label: 'accountName'
        }
      },
      {
        id: 'MarginCall',
        dataKey: 'MarginCall',
        class: 'marginCallArray',
        exportExcel: 'MarginCall',
        exportExcelFilePrefix: 'MarginCall',
        options: {
          title: 'Margin Call Clients',
          rootList: 'exportList',
          filter: 'sorting',
          list: 'clientList',
          label: 'accountName'
        }
      }
    ]
  }
  // {
  //   id: 'ccyExposure',
  //   class: 'Exposure',
  //   exportExcel: 'ProfitAndLoss',
  //   exportExcelFilePrefix: 'ProfitAndLoss',
  //   bookFilterId: '',
  //   optionsClass: 'SettingsMode',
  //   options: {
  //     title: 'Profit and Loss',
  //     rootList: 'currencyList',
  //     detailRootList: 'positionList',
  //     mode: '1', // affichage 1 large , 2 small
  //     filter: null,
  //     top: 0,
  //     left: 0,
  //     minWidth: 380,
  //     width: 1270,
  //     height: 230,
  //     z: 1,
  //     showBookFilter: false
  //   },
  //   status: 0
  // }
]

export const defaultDisplayedPanelList = [...defaultPanelList.filter(panel => panel.status===1)]
